/** Событие: текущий пользователь прочитал тред — обновить total_unread и список тредов (сокет peer не шлёт это читателю). */
export const MESSENGER_UNREAD_INVALIDATE = 'messenger-unread-invalidate';

/** Тихий refetch списка чатов Астры (processing / unread) после reconnect. */
export const MESSENGER_AGENT_CHATS_INVALIDATE = 'messenger-agent-chats-invalidate';

/**
 * После reconnect recover: UI открытого agent-чата синхронизирует кэш и при
 * `processing === false` останавливает локальный useChat SSE.
 */
export const MESSENGER_AGENT_CHAT_RECOVER = 'messenger-agent-chat-recover';

/** Клик по системному / push-уведомлению мессенджера — открыть тред (слушает ChatFab). */
export const MESSENGER_OPEN_THREAD_FROM_NOTIFICATION = 'messenger-open-thread-from-notification';
/** Клик по системному уведомлению Астры — открыть конкретный чат Астры (слушает ChatFab). */
export const MESSENGER_OPEN_AGENT_CHAT_FROM_NOTIFICATION = 'messenger-open-agent-chat-from-notification';

export type MessengerOpenThreadFromNotificationDetail = {
  threadId: string;
  threadKind: 'direct' | 'group';
  peerId: string | null;
  peerName: string | null;
  title: string | null;
};

export type MessengerOpenAgentChatFromNotificationDetail = {
  chatId: string;
};

export type MessengerAgentChatRecoverDetail = {
  chatId: string;
  processing: boolean;
};

export function invalidateMessengerUnread(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(MESSENGER_UNREAD_INVALIDATE));
}

export function invalidateMessengerAgentChats(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(MESSENGER_AGENT_CHATS_INVALIDATE));
}

export function emitMessengerAgentChatRecover(detail: MessengerAgentChatRecoverDetail): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(MESSENGER_AGENT_CHAT_RECOVER, { detail }));
}
